<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="300">
      <template v-slot:activator="{ on }">
        <v-tooltip
          bottom
          :color="$vuetify.theme.themes.light.tooltipColor"
          v-if="moduleName === 'Approve'"
        >
          <template v-slot:activator="{ on: tooltip, attrs }">
            <img
              class="mr-2"
              v-bind="attrs"
              v-on="{ ...on, ...tooltip }"
              src="@/assets/images/Approve.svg"
            />
          </template>
          <span>Approve</span>
        </v-tooltip>
      </template>
      <v-card v-if="moduleName === 'Approve'">
        <v-card-title class="card-title">Approve Request</v-card-title>
        <v-card-text>
          Are you sure want to
          <strong>Approve</strong> request ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="disAgree">Disagree</v-btn>
          <v-btn color="green darken-1" text @click="agree">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" persistent max-width="500px">
      <template v-slot:activator="{ on }">
        <v-tooltip
          bottom
          :color="$vuetify.theme.themes.light.tooltipColor"
          v-if="moduleName === 'Reject'"
        >
          <template v-slot:activator="{ on: tooltip, attrs }">
            <img
              class="mr-2"
              v-bind="attrs"
              v-on="{ ...on, ...tooltip }"
              src="@/assets/images/Reject.svg"
            />
          </template>
          <span>Reject</span>
        </v-tooltip>
      </template>
      <v-card class="dialog-cls" v-if="moduleName === 'Reject'">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="header-title">
            Rejection Reason
            <v-spacer></v-spacer>
            <v-icon color="white" class="vuetify-icon" @click="dialog2=false">close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="reason"
                    placeholder="Add a reason"
                    :rules="[(v) => !!v || 'Reason is required!']"
                    rows="3"
                    auto-grow
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#989898" class="mr-2 white--text" @click="dialog2=false">Cancel</v-btn>
            <v-btn
              :disabled="!valid"
              color="#344452"
              class="white--text"
              :loading="loading"
              @click="reject"
            >Send</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { CommunityService } from "@/services";

export default {
  name: "PermissionDialog",
  data() {
    return {
      dialog: false,
      dialog2: false,
      reason: undefined,
      valid: true,
      loading: false,
    };
  },
  props: {
    moduleName: String,
    Detail: Object,
    isStatus: Boolean,
  },
  methods: {
    async agree() {
      this.dialog = false;
      const response = await CommunityService.approveOrRejectRequest({
        channelId: this.Detail.channelId,
        userId: this.Detail.userId,
        status: this.isStatus,
      });
      if (response) {
        if (this.isStatus) {
          this.$store.dispatch(
            "user/setSnack",
            "Request approved successfully!"
          );
        } else {
          this.$store.dispatch(
            "user/setSnack",
            "Request declined successfully!"
          );
        }
        this.$emit("RequestHandled");
        this.$store.dispatch("user/setType", "info");
        this.$router.push("/requests");
      }
    },
    disAgree() {
      this.dialog = false;
    },
    async reject() {
      if (this.$refs.form.validate()) {
        this.dialog2 = false;
        const response = await CommunityService.approveOrRejectRequest({
          channelId: this.Detail.channelId,
          userId: this.Detail.userId,
          status: this.isStatus,
          reason: this.reason,
        });
        if (response) {
          this.$store.dispatch(
            "user/setSnack",
            "Request declined successfully!"
          );
          this.$emit("RequestHandled");
          this.$store.dispatch("user/setType", "info");
          this.$router.push("/requests");
        }
      }
    },
  },
  cancel() {
    this.dialog2 = false;
  },
};
</script>